import { FormKeys } from '@/features/pos/components/CustomerProfile/form/constants/keys'
import { DeliveryFormDefaultValues } from '@/features/pos/components/CustomerProfile/form/types'

export const deliveryDefaultValues = {
    [FormKeys.Phone]: { dialCode: '', number: '' },
    [FormKeys.Name]: '',
    [FormKeys.Address]: { address: '', coordinates: null, zone: null, isValid: null },
} as const satisfies DeliveryFormDefaultValues
